import { InfiniteData, useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { UserRewardRepositoryImpl } from "../../data/repository/user_reward_repository_impl";
import { RewardInterface } from "../../../home/domain/interface/reward_interface";

type ExceptionalRewardsPage = { rewards: RewardInterface[]; fetchedAll: boolean };

export const useClaimReward = () => {
  const repository = new UserRewardRepositoryImpl();
  const queryClient = useQueryClient();

  return useMutation<void, AxiosError, string>({
    mutationFn: (id: string) => repository.claimReward(id),
    onSuccess: (_, userRewardId) => {
      // Mark the reward as claimed right away: the refetch can still return the
      // previous state, which left the card on "Récupérer" until a reload.
      queryClient.setQueriesData<InfiniteData<ExceptionalRewardsPage>>(
        { queryKey: ['exceptionalRewards'] },
        (data) => data && {
          ...data,
          pages: data.pages.map((page) => ({
            ...page,
            rewards: page.rewards.map((reward) =>
              reward.userReward.id === userRewardId
                ? { ...reward, userReward: { ...reward.userReward, earned: true } }
                : reward
            ),
          })),
        }
      );
      queryClient.invalidateQueries({ queryKey: ['exceptionalRewards'] });
    }
  });
};
